import { PersonLegalFormEnum } from "../types/Api";
export var getPersonDetailPath = function (personId, legalForm) {
    if (legalForm === PersonLegalFormEnum.NATURAL) {
        return "/bragency/natural-persons/detail/".concat(personId);
    }
    if (legalForm === PersonLegalFormEnum.LEGAL) {
        return "/bragency/legal-persons/detail/".concat(personId);
    }
    return null;
};
